// src/utils/googleMapsLoader.js
import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey: process.env.REACT_APP_GEOCODING_API_KEY,
  version: "weekly",
  libraries: ["places"],
});

export default loader;
